/*
 * Ce module gère l'affichage ou non des modal de création de compte et login suite à l'arrive d'un utilisateur 
 * via une URL pour offrir un article
 *
 * Ce module permet également d'afficher la modale qui indique que l'utilisateur à des articles gratuit en attente de lecture
 */
(function ($, Global) {
    var urlParams = new UrlParams();
    var OffrirArticleCatcher = function (model) {
        this.model = model;
    }

    OffrirArticleCatcher.prototype.initEvents = function () {
        this.publishers();
    }

    OffrirArticleCatcher.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
            var params = urlParams.getParams();
            var email = params["email"];

            if ($('.modal-holder-offrir-article-id').exists() && email !== undefined && email !== "") {
                
                
                self.model.checkArticleOffertUser(email,
                    function (data) {

                        var nomModalCookieConsent = '#modalCookieConsent';
                        var bModalAccepterCookieEnCoursAffichage = ($(nomModalCookieConsent).exists() && $(nomModalCookieConsent).hasClass('in'));
                        
                        
                        if (!data.isSuccess) return;
                        var retour = data.data;

                        if (retour.codeRetour === 1)  //Utilisteur est deja connu dans la DB ( compte valide)
                        {
                            var nomModalePourIdenfitierUserArticleOffert = '.modal-offrir-article-identify';
                            if ($(nomModalePourIdenfitierUserArticleOffert).exists()) {

                                //N'affiche pas la modal de login si la modal des cookie est encore affiché (pour éviter la superposition)
                                if (bModalAccepterCookieEnCoursAffichage)
                                {
                                    $(nomModalCookieConsent).on('hide.bs.modal', function (e) {
                                        $(nomModalePourIdenfitierUserArticleOffert).modal('show');
                                    });
                                } else 
                                {
                                    $(nomModalePourIdenfitierUserArticleOffert).modal('show');
                                }
                                
                                $(nomModalePourIdenfitierUserArticleOffert).find('.identify .title').hide(); //Masque la partie pour créer un compte

                                var input = $(nomModalePourIdenfitierUserArticleOffert).find("input[name=Identifiant]");
                                input.val(email); // Set l'email par defaut de l'utilisateur
                                input.prop('readonly', 'readonly'); // Pas de modif de l'email possible

                            }
                        }
                        else if (retour.codeRetour === 2)  //Utilisateur connu mais compte invalide (pas d'identifiant ou mdp par exemple)
                        {
                            var nomModalePourCreerCompteUserArticleOffert = '.modal-offrir-article-createaccount';
                            if ($(nomModalePourCreerCompteUserArticleOffert).exists()) {
                                
                                //N'affiche pas la modal de creation de compte si la modal des cookie est encore affiché (pour éviter la superposition)
                                if (bModalAccepterCookieEnCoursAffichage) 
                                {
                                    $(nomModalCookieConsent).on('hide.bs.modal', function(e) { $(nomModalePourCreerCompteUserArticleOffert).modal('show'); });
                                } else 
                                {
                                    $(nomModalePourCreerCompteUserArticleOffert).modal('show');
                                }
                                
                                
                                var input = $(nomModalePourCreerCompteUserArticleOffert).find("input[name=Identifiant]");
                                input.val(email); // Set l'email par defaut de l'utilisateur
                                input.prop('readonly', 'readonly'); // Pas de modif de l'email possible

                                
                            }
                        }


                    });
            }

            //Si modal des article offert en attente présente, affiche la modal
            if ($('.modal-offrir-article-enattente').exists())
            {
                $('.modal-offrir-article-enattente').modal('show');
            }
        });



    }

    Global.OffrirArticleCatcher = OffrirArticleCatcher;
}(jQuery, window));